import api from '@/api'

const PRIVACY_LABEL = '(FOR INTERNAL USE ONLY)'
const BINARY_FILE_MIME_TYPE = 'application/octet-stream'

export default {
  getReportsList(_context, organizationId) {
    return api.report.getReportsList(organizationId).then(result => {
      return result.data
    })
  },

  async getReport(_context, { organizationId, options }) {
    const result = await api.report.getReport(
      organizationId,
      options
    )
    return result.data
  },

  updateRev(_context, { organizationId, revType, revId, data }) {
    const lowercaseRevType = revType.replace(/-/g, '').toLowerCase()
    return api[lowercaseRevType].update(organizationId, revId, data)
  },

  async getAllOrganizations(_context, options) {
    const response = await api.organization.getAll(options)
    return response.data
  },

  generateReport(_context, payload) {
    const reportOptions = payload
    return api.report
      .generateReport(reportOptions)
      .then(response => {
        return response.data
      })
      .catch(error => {
        return error
      })
  },

  async downloadReport(context, payload) {
    try {
      const organizationId = context?.rootGetters?.organizationId
      const { reportKey, type } = payload

      if (!reportKey) return false

      const response = await api.report.getReportXlsxFile(
        organizationId,
        reportKey
      )
      const isBinaryFile =
        response?.data &&
        response?.headers?.['content-type']?.startsWith?.(BINARY_FILE_MIME_TYPE)

      if (!isBinaryFile) return response.data

      const reportBlob = new window.Blob([response.data], {
        type: BINARY_FILE_MIME_TYPE,
      })

      const today = new Date().toISOString().substring(0, 10)
      const fileName = `rever-report_${type}_${today}_${reportKey} ${PRIVACY_LABEL}.xlsx`

      if (navigator.msSaveBlob) {
        return navigator.msSaveBlob(reportBlob, fileName)
      }

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(reportBlob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      return { status: 'success' }
    } catch (error) {
      return error
    }
  },
}
